/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";

import { FormControl, FormControlLabel, Switch, FormHelperText } from '@material-ui/core'

class FlexSwitch extends Component {
  state = {
    checked: false,
  };
  componentWillMount() {
    console.log("Type: ", this.props.instance.component);
    console.log("ID: ", this.props.instance.id);
    this.setState({
      ...this.state,
      checked: this.props.instance.value.boolean,
    });
  }

  handleChange = (event) => {
    this.setState({ ...this.state, checked: event.target.checked }, () => this.props.update_value(this.props.instance.id, "boolean", this.state.checked));
  };

  getParam = (param_name, value_type) => {
    let parameter = null

    if (this.props.instance.component_params !== null) {
        this.props.instance.component_params.map(param => {
            if (param.name === param_name) {
                parameter = param.value[value_type]
            }
        })
    }

    return parameter
  }
  
  render() {
    return (
      <div>
        <FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={this.state.checked}
                onChange={this.handleChange}
                name="checked"
                inputProps={{ "aria-label": "secondary checkbox" }}
                disabled={this.props.disabled}
              />
            }
            label={this.getParam("label", "text") !== null ? this.getParam("label", "text") : this.props.instance.name}
          />
          <FormHelperText>{this.getParam("helper_text", "text")}</FormHelperText>
        </FormControl>
      </div>
    );
  }
}

export default FlexSwitch;
